import { Instance, Objekt, Table } from '@siposdani87/sui-js';
import { app } from '../app';
import { resources } from '../resources';
import { AdminChamberService } from '../services/adminChamberService';
import { LanguageService } from '../services/languageService';
import { AdminController } from './adminController';

export class AdminChambersIndexController extends AdminController {
    private table: Table;

    constructor(
        instances: Instance,
        private adminChamberService: AdminChamberService,
        private languageService: LanguageService,
    ) {
        super(instances);
    }

    protected override _initToolbarButtons(): void {
        this.helper.iconButton(
            '.btn-admin-index',
            this.dom,
            () => {
                this.state.goBack('admin.index');
            },
            '',
            true,
            [],
        );

        this.helper.iconButton('.btn-chambers-new', this.dom, () => {
            this.adminChamberService.newDialogByAdmin().then(() => {
                this._drawContent();
            });
        });
    }

    protected override _initTable(): void {
        if (!this.table) {
            this.table = new Table(
                this.dom,
                'table',
                this.adminChamberService.getTableOptions(),
            );

            this.table.setActions([
                {
                    style: () => {
                        return [
                            'edit',
                            this.languageService.translate('buttons.edit'),
                        ];
                    },
                    click: (chamber) => {
                        this.adminChamberService
                            .editDialog(chamber, '/admin/')
                            .then(() => {
                                this._drawContent();
                            });
                    },
                },
            ]);

            this.table.eventAction = (params) => {
                params.set('query', this.query);
                params.set('fields', this.adminChamberService.getTableFields());
                this.adminChamberService.getAll(params).then((response) => {
                    const count = response.get<number>('count');
                    this.table.setCount(count);
                    const chambers = response.get<Objekt[]>('chambers');
                    this.table.setData(chambers);
                });
            };

            this.table.render();
        } else {
            this.table.refresh();
        }
    }
}

export const adminChambersIndexController = app.controller(
    resources.adminChambersIndexController,
    [
        resources.instances,
        resources.adminChamberService,
        resources.languageService,
    ],
    AdminChambersIndexController,
);
